import styled from "styled-components";

import { alignItemsCenter, flexSpBetween } from "@styles/Utilities.styled";


export const StyledIncoming = styled.div`
  margin-top: 2rem;

  .tab-content-container {
    margin-top: 2rem;
  }

  .nested-header {
    ${flexSpBetween}
    gap: 2rem;

    .wrapper {
      ${alignItemsCenter}
      gap: 1rem;
    }
  }
`;
